import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedState, setDebouncedState] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedState(value), delay ?? 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedState;
}
